var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin":"-5px 0"}},_vm._l((_vm.warnings),function(warning){return _c('WarningListEntry',{key:warning.id})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }